var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("bulma-autocomplete", {
    attrs: {
      id: "item-description-autocomplete",
      data: _vm.items,
      field: "description",
      "class-prop": _vm.classProp,
      "keep-first": true,
      expanded: true,
    },
    on: { input: _vm.getItemMasterByTimesStyle, select: _vm.select },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c(
              "div",
              { staticClass: "is-flex is-justify-content-space-between" },
              [
                _c("span", [_vm._v(_vm._s(props.option.description))]),
                _c("div", { staticClass: "tags" }, [
                  props.option.itemNo
                    ? _c(
                        "span",
                        {
                          staticClass: "tag alpha-code-tag",
                          class: [
                            _vm.innerValue.toLowerCase() ===
                            props.option.itemNo.toLowerCase()
                              ? "is-success"
                              : `is-${_vm.$theme.name}`,
                          ],
                        },
                        [_vm._v(_vm._s(props.option.itemNo))]
                      )
                    : _vm._e(),
                  props.option.bmItemNo
                    ? _c(
                        "span",
                        {
                          staticClass: "tag alpha-code-tag",
                          class: [
                            _vm.innerValue.toLowerCase() ===
                            props.option.bmItemNo.toLowerCase()
                              ? "is-success"
                              : `is-${_vm.$theme.name}`,
                          ],
                        },
                        [_vm._v(_vm._s(props.option.bmItemNo))]
                      )
                    : _vm._e(),
                  props.option.alphaCode
                    ? _c(
                        "span",
                        {
                          staticClass: "tag alpha-code-tag",
                          class: [
                            _vm.innerValue.toLowerCase() ===
                            props.option.alphaCode.toLowerCase()
                              ? "is-success"
                              : `is-${_vm.$theme.name}`,
                          ],
                        },
                        [_vm._v(_vm._s(props.option.alphaCode))]
                      )
                    : _vm._e(),
                  props.option.bmAlphaCode
                    ? _c(
                        "span",
                        {
                          staticClass: "tag alpha-code-tag",
                          class: [
                            _vm.innerValue.toLowerCase() ===
                            props.option.bmAlphaCode.toLowerCase()
                              ? "is-success"
                              : `is-${_vm.$theme.name}`,
                          ],
                        },
                        [_vm._v(_vm._s(props.option.bmAlphaCode))]
                      )
                    : _vm._e(),
                  props.option.pnpAlphaCode
                    ? _c(
                        "span",
                        {
                          staticClass: "tag alpha-code-tag",
                          class: [
                            _vm.innerValue.toLowerCase() ===
                            props.option.pnpAlphaCode.toLowerCase()
                              ? "is-success"
                              : `is-${_vm.$theme.name}`,
                          ],
                        },
                        [_vm._v(_vm._s(props.option.pnpAlphaCode))]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.innerValue,
      callback: function ($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }